<template>
  <div>
    <a-drawer :title="`${storyId ? '修改' : '起草'}${'合同'}`" :width="960" :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="close('cancel')">
      <a-form-model ref="form" :rules="rules" :model="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="合同标题" prop="title">
              <a-input v-model="form.title" placeholder="请填写标题" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="合同类型" prop="requirement_type" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.requirement_type" :disabled="isStory">
                <a-select-option v-for="(item, key) in contractTypes" :key="key" :value="item.value">
                  <a-badge :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="优先级" prop="priority" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.priority" placeholder="优先级" style="width: 100%" allow-clear @change="handleChange">
                <a-select-option v-for="item in ['P0', 'P1', 'P2', 'P3']" :key="item" :value="item"> {{ item }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item v-if="sourceType != 'ticket'" label="主合同" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-tree-select v-model="parentRequirement" label-in-value show-search :filter-tree-node="fillterRequirement" :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择父需求" :tree-data="requirementData" :tree-expanded-keys.sync="expendedKeys" :search-value.sync="searchValue" allow-clear dropdown-match-select-width @change="onChange" @select="onSelect" @search="getStoryTree" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-if="sourceType != 'ticket'" label="业务背景" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-tree-select v-model="parentRequirement" label-in-value show-search :filter-tree-node="fillterRequirement" :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择父需求" :tree-data="requirementData" :tree-expanded-keys.sync="expendedKeys" :search-value.sync="searchValue" allow-clear dropdown-match-select-width @change="onChange" @select="onSelect" @search="getStoryTree" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-if="sourceType == 'ticket'" label="所属项目" prop="project_id" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.project_id" placeholder="所属项目">
                <a-select-option v-for="item in projects" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item label="负责人" prop="handlers" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.handlers" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="12">
            <a-form-model-item label="技术负责人" prop="tech_owner" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.tech_owner" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="12">
            <a-form-model-item label="开始时间" prop="start_time" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.start_time" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="结束时间" prop="end_time" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.end_time" :disabled-date="disabledEndDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择结束时间" />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="12">
            <a-form-model-item label="需求评审时间" prop="is_review" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.is_review" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="技术评审时间" prop="technical_review" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.technical_review" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择开始时间" />
            </a-form-model-item>
          </a-col> -->
        </a-row>
        <!-- <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="产品" prop="pm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.pm" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="运营" prop="operators" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.operators" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row> -->
        <!-- <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="质量" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.qa" mode="multiple" show-search :filter-option="utils.filterOption">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="故事点" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-input-number v-model="form.point" style="width: 100%" :max="100" />
            </a-form-model-item>
          </a-col>
        </a-row> -->
        <!-- <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="需求标签" prop="tag">
              <div style="position: relative">
                <a-select v-model="form.tag" mode="multiple" :max-tag-count="5" placeholder="请选择需求标签" disabled>
                  <a-select-option v-for="(item, index) in tagData" :key="index" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>
          </a-col>
        </a-row> -->
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="协议概述" prop="description" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <AmEditor ref="AmEditor" :content="form.description" :drag="true" height="150px" :tool-bar="toolBar" @change="descChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="价值预估" prop="preValues" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <AmEditor ref="AmEditor" :content="form.preValues" :drag="true" height="150px" :tool-bar="toolBar" @change="descChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-model-item label="交付范围" prop="ranges" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <AmEditor ref="AmEditor" :content="form.ranges" :drag="true" height="150px" :tool-bar="toolBar" @change="descChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="结算方式" prop="payMethod" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.requirement_type" :disabled="isStory">
                <a-select-option v-for="(item, key) in contractTypes" :key="key" :value="item.value">
                  <a-badge :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="数额" prop="payAmount" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-input placeholder="填写现金或者百分比" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="交付日期" prop="technical_review" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-date-picker v-model="form.technical_review" :disabled-date="disabledStartDate" value-format="YYYY-MM-DD" style="width: 100%" placeholder="请选择交付日期" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-model-item label="违约条款" prop="payMethod" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-select v-model="form.requirement_type" :disabled="isStory">
                <a-select-option v-for="(item, key) in contractTypes" :key="key" :value="item.value">
                  <a-badge :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="drawer-bottom-menu">
        <a-button :style="{ marginRight: '8px' }" @click="close('cancel')"> 取消 </a-button>
        <a-button v-if="storyId === null" :loading="loading" :style="{ marginRight: '8px' }" @click="onSubmit('next')"> 完成并创建下一个 </a-button>
        <a-button type="primary" :loading="loading" @click="onSubmit('ok')"> 完成 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import AmEditor from '@/components/AmEditor/index';
import { storyStatus, contractTypes, storyPrioritys, contractDescription, contractPayType } from '@/utils/dictionary';
import { storyUpdate, storyAdd, storyTree, storyDetail } from '@/api/project/story';
import moment from 'moment';
import { projectList, projectInvolvedList } from '@/api/project/project';
import { tagList } from '@/api/system/tag';
import { getCookies } from '@/utils/utils';

const toolBar = [
  [
    {
      type: 'collapse',
      groups: [
        {
          items: ['image-uploader', 'codeblock', 'table', 'file-uploader', 'video-uploader', 'math', 'status']
        }
      ]
    }
  ],
  // ["undo", "redo", "paintformat", "removeformat"],
  ['heading', 'fontfamily', 'fontsize'],
  // ["bold", "italic", "strikethrough", "underline", "moremark"],
  ['bold', 'italic', 'strikethrough', 'underline'],
  ['fontcolor', 'backcolor'],
  ['alignment'],
  ['unorderedlist', 'orderedlist', 'tasklist', 'indent']
  // ["link", "quote", "hr"],
];

export default {
  components: { AmEditor },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isStory: {
      type: Boolean,
      default: false
    },
    storyId: {
      type: [Array, Number, String],
      default: null
    },
    versionId: {
      type: [Number, String],
      default: null
    },
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    sourceId: {
      type: [Array, Number, String],
      default: null
    },
    sourceType: {
      type: [Array, Number, String],
      default: null
    },
    parent: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      storyStatus,
      contractTypes,
      contractDescription,
      storyPrioritys,
      contractPayType,
      toolBar,
      projects: [],
      tagData: [],
      loading: false,
      uploading: false,
      actionUrl: `${process.env.VUE_APP_DADA_URL}/v1/basic/resourceUpload`,
      headers: {
        Authorization: getCookies()
      },
      data: {
        resource_type: 2
      },
      fileList: [],
      searchValue: '',
      requirementData: [],
      parentRequirement: { key: null },
      expendedKeys: [],
      form: {
        parent_id: null,
        attach: null,
        description: contractDescription[1],
        start_time: null,
        project_id: null,
        end_time: null,
        pm: [],
        preValues: null,
        ranges: null,
        operators: []
      },
      description: contractDescription[1],
      preValues: '',
      ranges: '',
      projectId: parseInt(this.$route.params.project_id) || null,
      replaceFields: { key: 'id', value: 'id' },
      rules: {
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '状态不能为空', trigger: 'blur' }],
        requirement_type: [{ required: true, message: '需求类型不能为空', trigger: 'blur' }],
        description: [{ required: true, message: '描述内容不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    userData() {
      return this.utils.getUserData(this.projectId === null ? 0 : this.projectId);
    }
  },
  watch: {
    parent() {
      this.parentRequirement = this.parent;
      this.form.parent_id = this.parentRequirement.key;
      if (this.parent && this.form.parent_id) {
        this.getStoryDetail(this.parentRequirement.key);
      }
    },

    visible() {
      if (this.visible === true) {
        this.getTagList();
        if (this.sourceType !== 'ticket') {
          this.getStoryTree();
        } else {
          this.getProjectList();
        }

        this.getProjectList();
        if (this.storyId) {
          this.parentRequirement = { key: this.dataSource.parent_id, label: this.dataSource.parent_title };
          this.form = {
            id: this.dataSource.id,
            title: this.dataSource.title,
            start_time: this.dataSource.start_time || null,
            end_time: this.dataSource.end_time || null,
            requirement_type: this.dataSource.requirement_type,
            status: this.dataSource.status,
            description: this.dataSource.description || '',
            comment: this.dataSource.comment,
            priority: this.dataSource.priority,
            project_id: this.dataSource.project_id || null,
            is_review: this.dataSource.is_review,
            technical_review: this.dataSource.technical_review,
            pm: this.getUsers(this.dataSource.pm),
            qa: this.getUsers(this.dataSource.qa),
            handlers: this.getUsers(this.dataSource.handlers),
            operators: this.getUsers(this.dataSource.operators),
            parent_id: this.dataSource.parent_id,
            point: this.dataSource.point,
            tech_owner: this.getUsers(this.dataSource.tech_owner),
            tag: this.dataSource.tags.map(item => {
              return item.id;
            })
          };
        } else {
          this.form = {
            ...this.form,
            description: this.description,
            start_time: null,
            project_id: null,
            end_time: null,
            requirement_type: this.isStory ? 4 : null
          };
        }
      } else {
        this.form = {
          attach: null,
          project_id: null,
          description: ''
        };
      }
    }
  },
  methods: {
    close(type = 'submit') {
      this.loading = false;
      this.fileList = [];
      this.$refs.form.resetFields();
      this.$emit('close', type);
    },

    getUsers(users) {
      return users ? users.map(item => item.id) : [];
    },
    getTagList() {
      tagList({ group_code: 'task_req_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    descChange(content) {
      this.form.description = content;
    },
    // 需求筛选
    fillterRequirement(searchValue, treeNode) {
      return treeNode.data.props.title.includes(searchValue);
    },

    getStoryTree() {
      this.requirementData = [];
      this.expendedKeys = [];
      storyTree({ project_id: this.projectId, page_index: 1, page_size: 20, title: this.searchValue, skip_story: true }).then(res => {
        this.requirementData = [{ id: 0, title: '根需求' }, ...res.data.items];
        this.expendedKeys = res.data.requirement_ids;
      });
    },
    getProjectList() {
      if (this.projectId === null) {
        projectInvolvedList({}).then(res => {
          this.projects = res.data.items;
        });
      } else {
        projectList({}).then(res => {
          this.projects = res.data.projects;
        });
      }
    },
    onChange() {
      this.form.parent_id = this.parentRequirement.value;
    },

    onSelect(nodeVal) {
      if (this.storyId === null && nodeVal) {
        this.getStoryDetail(nodeVal.value);
      }
    },
    getStoryDetail(storyId) {
      storyDetail({ requirement_id: storyId, project_id: this.projectId }).then(res => {
        this.form.pm = res.data.item.pm.map(p => p.id);
        this.form.operators = res.data.item.operators.map(p => p.id);
      });
    },

    disabledStartDate(startValue) {
      const endValue = moment(this.form.end_time || null);
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },

    disabledEndDate(endValue) {
      const startValue = moment(this.form.start_time || null);
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },

    handleChange({ fileList }) {
      var attach = [];
      if (fileList instanceof Array) {
        this.fileList = fileList;
        this.uploading = false;
        this.fileList.forEach(item => {
          if (item.status === 'uploading') {
            this.uploading = true;
          }
          if (item.response && item.response.code === 2000) {
            attach.push(item.response.data);
          }
        });
        this.form.attach = JSON.stringify(attach);
      }
    },

    onSubmit(type) {
      if (this.form.project_id === null) {
        this.form.project_id = this.projectId;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.storyId) {
            storyUpdate({ ...this.form, requirement_id: this.storyId })
              .then(() => {
                this.$message.success('需求修改成功');
                this.close();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            storyAdd({ ...this.form, version_id: this.versionId })
              .then(res => {
                this.$message.success('需求添加成功');
                if (this.sourceType === 'ticket') {
                  this.$emit('callback', res.data.id, 'requirement');
                }
                if (type === 'next') {
                  const parent_id = this.form.parent_id;
                  const project_id = this.form.project_id;
                  this.form = {
                    attach: null,
                    description: '',
                    parent_id: parent_id,
                    project_id: project_id,
                    version_id: this.versionId
                  };
                  this.loading = false;
                } else {
                  this.close();
                }
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.drawer-bottom-menu {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

/deep/.ant-form-item {
  margin-bottom: 16px;
}
</style>
